export interface ErrorInterface {
    code: number | null;
    message: string;
    userMessage: string;
}

export function toError(errorData: any): ErrorInterface {
    const error: ErrorInterface = {
        code: null,
        message: '',
        userMessage: '',
    };

    if (typeof errorData === 'object') {
        if (errorData.code) {
            error.code = Number(errorData.code);
        }

        if (errorData.message) {
            error.message = String(errorData.message);
        }

        if (errorData.data && errorData.data.userMessage) {
            error.userMessage = String(errorData.data.userMessage);
        }
    }

    return error;
}
